<template>
    <div class="container mt-5">
        <h3>BeNeat Blog</h3>
        <!-- <div class="blog-list" v-if="blogs">
            <div class="blog-card" v-for="blog in blogs" :key="index">
                <section class="img">
                    <img class="img-card" :src="blog.post_image_url" alt="">
                </section>
                <section class="content">
                    <div class="title-card">{{ blog.post_title }}</div>
                    <div class="description-crad">
                        <p>{{ blog.post_content }}</p>
                    </div>
                    <div class="detail-crad">
                        <div class="created-by">By BeNeat</div>
                        <div><i class="time"></i>{{ blog.updated_at | prettyOnlyDate }}</div>
                    </div>
                </section>
            </div>
        </div> -->
        <Blogs :curPage="curPage" :queryDataPage="queryData.page" :queryDataLimit="queryData.limit" @visiblePageNumber="visiblePageNumber" ref="blog-component" :showInPageConent="false"></Blogs> 
        <div class="pagination" v-if="totalPage > 1">
            <nav class="d-flex justify-content-center">
                <a href="" @click.prevent="changePage(curPage - 1)" :disabled="curPage === 1"><i class="fa fa-angle-left" aria-hidden="true"></i><span class="text-pagination-back">&nbsp;Back</span></a>
                <a href="" v-for="pageNumber in visiblePageNumber(totalPage)" 
                    :key="pageNumber"
                    :class="{active: curPage == pageNumber}"
                    @click.prevent="changePage(pageNumber)">
                    {{ pageNumber }}
                </a>
                <a href="" @click.prevent="changePage(curPage + 1)" :disabled="curPage === totalPage"><span class="text-pagination-next">Next&nbsp;</span><i class="fa fa-angle-right" aria-hidden="true"></i></a>
            </nav>
        </div>
    </div>
</template>
<script>
    import Blogs from './components/Blogs.vue'

    export default {
      components: {
        Blogs
      },
      metaInfo: {
        title: 'BeNeat - Blog'
      },
      data () {
        return {
          blogs: [],
          loading: false,
          queryData: {
            page: 0,
            limit: 9
          },
          curPage: 1,
          totalPage: 0
        }
      },
      methods: {
        changePage (page) {
          if (page >= 1 && page <= this.totalPage) {
            console.log('select page', page)
            this.curPage = page
            this.queryData.page = page - 1
          }
          this.$refs['blog-component'].getBlogsData(this.queryData.page)
        },
        visiblePageNumber (totalPage) {
          // console.log('function visiblePageNumber')
          this.totalPage = totalPage
          let pageNumbers = []
          if (totalPage <= 5) {
            for (let i = 1; i <= totalPage; i++) {
              pageNumbers.push(i)
            }
          } else {
            if (this.curPage <= 3) {
              pageNumbers = [1, 2, 3, '...', totalPage]
            } else if (this.curPage >= totalPage - 3) {
              pageNumbers = [1, '...', totalPage - 2, totalPage - 1, totalPage]
            } else {
              pageNumbers = [1, '...', this.curPage, '...', totalPage]
            }
          }
          return pageNumbers
        }
      }
      // watch: {
      //   '$route' (to, from) {
      //     document.title = to.meta.title || 'Other Title'
      //     console.log('title', document.title)
      //   }
      // }
    }
</script>
<style scoped lang="scss">
h3 {
    font-size: 24px;
    font-weight: 600;
}
.blog-list {
    margin-top: 24px;
    column-gap: 24px;
    row-gap: 32px;
    display: grid;
    grid-template-columns: auto auto auto;
}
.blog-card {
    width: 100%;
    height: auto;
}
.blog-card:hover {
    width: 100%;
    height: auto;
    .title-card{
        font-size: 18px;
        font-weight: 600;
        color: #00B4CD;
    }
    .img-card {
        width: 100%;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
}
.description-crad p{
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 14px;
    font-weight: 400;
    color: #7F7F7F;
    margin-top: 14px;
}
.title-card {
    font-size: 18px !important;
    font-weight: 600;
}
.detail-crad {
    display: flex;
    column-gap: 40px;
    align-items: center;
    color: #7F7F7F;
}
.time {
    background: url('/static/img/Vector.png');
    background-size: 20px 20px;
    position: absolute;
    width: 20px;
    height: 20px;
    margin-left: -27px;
    margin-top: 2px;
}
.detail-crad .created-by {
    font-size: 14px;
    font-weight: 400;
    color: #4D4D4D;
}
.img-card {
    width: 100%;
}
.content {
    margin-top: 24px;
}
.pagination {
    margin-top: 64px;
    margin-bottom: 124px;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
}
.pagination nav a {
  border: 1px solid #E9E9E9;
  border-radius: 4px;
  padding: 8px 12px 8px 12px;
  margin-left: 6px;
  color: #313131;
}
.pagination nav a.active {
  background-color: #00B4CD;
  color: #FFFFFF;
}
.pagination nav a[disabled] {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.7;
}


@media (max-width: 425px) {
  .blog-list {
    grid-template-columns: auto;
  }
  .text-pagination-back, .text-pagination-next {
    display: none;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/blogs/Index.vue